import React from 'react';
import SimplePagesComponent from '../../../components/simple-pages';
const SimplePages = () => (
  <SimplePagesComponent/>
)

export default SimplePages;
